import { useInstantSearch } from 'react-instantsearch-core';

export interface SearchEmptyQueryBoundaryProps {
    children: JSX.Element | JSX.Element[];
    fallback?: JSX.Element | JSX.Element[];
}

export function SearchEmptyQueryBoundary(props: SearchEmptyQueryBoundaryProps) {
    const { children, fallback } = props;
    const { indexUiState } = useInstantSearch();

    if (!indexUiState.query) {
        return fallback || null;
    }

    return children;
}

export default SearchEmptyQueryBoundary;
